import React, { Fragment, ReactNode } from 'react'

import AssetLink from '~/components/Scheme/AssetLink'
import DeletedUserIcon from '~/components/User/DeletedUserIcon'
import * as routes from '~/constants/routes'
import { useCurrentScheme } from '~/hooks'
import { truncateUserStr } from '~/utils/truncate'

export type User = {
  id: string
  email?: string | null
  deleted?: boolean
}

type Props = {
  user?: User | null
  fallback?: string | ReactNode
}

const UserLink: React.FC<Props> = ({ user, fallback, children }) => {
  const { currentSchemeId } = useCurrentScheme()
  if (!user) {
    return <Fragment>{fallback}</Fragment>
  }

  return (
    <AssetLink
      id={user.id}
      basePath={routes.USERS}
      elementId={`${user.id}-user-link`}
      schemeId={currentSchemeId}
    >
      {children || (
        <span>
          {truncateUserStr(user.email || user.id)}
          {user.deleted && <DeletedUserIcon />}
        </span>
      )}
    </AssetLink>
  )
}

export default UserLink
